import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43abc336"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-loader" }
const _hoisted_2 = {
  key: 0,
  class: "spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "image-loader-error"
}

import { onBeforeMount, provide, ref } from "vue";
import ExpandableMedia from "./ExpandableMedia.vue";

type LoadingState = "loading" | "failed" | "loaded";
type ImageProps = {
  image: string;
  media: string | null | undefined;
  arweaveUrl: string | null | undefined;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageLoader',
  props: {
    image: {},
    media: {},
    arweaveUrl: {}
  },
  setup(__props: any) {

const props = __props;


const state = ref<LoadingState>("loading");
const mediaIsVideo = ref(false);
const mediaIsAudio = ref(false);
const mediaIsModel = ref(false);
const mediaIsOther = ref(false);
const mediaAudioType = ref("");

// This get initialize on component mount
const mediaOptimized = ref();
const imageOptimized = ref();
provide("image", imageOptimized);
provide("media", mediaOptimized);
provide("mediaIsVideo", mediaIsVideo);
provide("mediaIsAudio", mediaIsAudio);
provide("mediaIsModel", mediaIsModel);
provide("mediaIsOther", mediaIsOther);
provide("mediaAudioType", mediaAudioType);

const onLoad = () => {
  state.value = "loaded";
};
const onError = () => {
  state.value = "failed";
};
provide("onLoadOnError", {
  onLoad,
  onError,
});

const parseTokenMetadata = async (
  url: string,
  isTokenMedia: boolean
): Promise<string> => {
  const response = await fetch(url);

  const metadata = await response.json();
  if (isTokenMedia) {
    if (metadata.animation_url || metadata.animation) {
      return metadata.animation_url || metadata.animation;
    }
  }
  return metadata.image_url || metadata.image;
};

const getOptimizedLink = (url: string) => {
  return url;
};

const getProcessedUrl = async (
  url: string,
  isTokenMedia: boolean
): Promise<string> => {
  // show optimized link for cloudinary
  const optimizedUrl = url;

  let processedUrl = optimizedUrl;
  let response;
  response = await fetch(optimizedUrl, { method: "HEAD" });
  // Fall back to arweave if cloudinary doesn't work
  if (response.status !== 200) {
    if (props.arweaveUrl) {
      const arweaveUrl = await parseTokenMetadata(
        props.arweaveUrl,
        isTokenMedia
      );
      // refetch for accurate header info
      response = await fetch(arweaveUrl, { method: "HEAD" });
      processedUrl = arweaveUrl;
    } else {
      processedUrl = url;
    }
  }
  const contentType = response.headers.get("content-type");
  if (contentType?.includes("video")) {
    mediaIsVideo.value = true;
  }
  if (contentType?.includes("audio")) {
    mediaIsAudio.value = true;
    mediaAudioType.value = contentType;
  }

  if (contentType?.includes("model")) {
    mediaIsModel.value = false;
  }
  if (contentType?.includes("html")) {
    mediaIsOther.value = true;
  }
  return processedUrl;
};

const initializeImageUrl = async () => {
  if (props.image) {
    imageOptimized.value = await getProcessedUrl(props.image, false);
  }
};

const initializeMediaUrl = async () => {
  if (props.media) {
    mediaOptimized.value = await getProcessedUrl(props.media, true);
  }
};

onBeforeMount(async () => {
  await initializeImageUrl();
  await initializeMediaUrl();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (state.value === 'loading')
      ? (_openBlock(), _createElementBlock("i", _hoisted_2))
      : (state.value === 'failed')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "error")
          ]))
        : _createCommentVNode("", true),
    _createVNode(ExpandableMedia)
  ]))
}
}

})